import React, { Component } from "react";
import axios from "axios";
import "./styles/styles.css";
import {
  Button,
  TextField,
  Paper,
  

  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,



  FormControl,
  Collapse,Alert
} from "@mui/material";
import Serverurl from "./Apiurl";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import Autocomplete from "@mui/material/Autocomplete";
import EditIcon from '@mui/icons-material/EditSquare';
import { makeStyles } from '@mui/styles'; 
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import {InputAdornment} from "@mui/material";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import NotesIcon from '@mui/icons-material/Notes';

import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

import ListAltIcon from '@mui/icons-material/ListAlt';
const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});
class ContractCostMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ccm_id: 0,
      ccm_pj_id: "",
      ccm_se_id: "",
      ccm_vm_id: "",
      ccm_agreedcost: "",
      ccm_remarks: "",

      contractcostlist: [],
      projectList: [],
      serviceList: [],
      vendorList: [],
	  // Project
projectarray: [],
projectarrauto: [],
selectedProject: null,
serProject: null,
// Service
servicearray: [],erropen:false,errormessage:"",
servicearrauto: [],
selectedService: null,
serService: null,
// Vendor
vendorarray: [],
vendorarrauto: [],
selectedVendor: null,
serVendor: null,
      page: 0,
      rowsPerPage: 10,
      totalRecords: 0,
      openEdit: false,
      openInsert: false,
    };
  }
  
  
  componentWillMount() { 
		if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
let strname="Contractor Cost Mapping";   
			 this.props.parentsCallback(
           strname
        );
		
		document.title = "VR Builders - Cost Mapping";
	
let search = window.location.href;
	let projectId = this.getParameterByName('projectid',search);	
	let vmid = this.getParameterByName('vmid',search);
	
	
	if (projectId!==null && vmid!==null) {
    this.loadVendorById(vmid);
        this.loadProjectById(projectId); 
  } else {
    this.loadProjects();
  this.getAll();
  }

  
}

loadVendorById = (vmid) => {
  axios
    .get(Serverurl + "ajaxvendor.php", {
      params: {
        action: "getall",
        vm_id: vmid
      }
    })
    .then((res) => {
      const data = res.data?.[0]; 
 if (data) {
        this.setState({
          serVendor: {
            title: data.vm_vendorname,
            vm_id: data.vm_id
          }
        },()=>{ });
      }
    });
};
loadProjectById = (projectId) => {
  axios
    .get(Serverurl + "ajaxprojects.php", {
      params: {
        action: "getall",
        pj_id: projectId
      }
    })
    .then((res) => {
		
      const data = res.data?.[0];

      if (data) {
        this.setState({
          serProject: {
            title: data.pj_projectname,
            pj_id: data.pj_id
          }
        },()=>{  this.loadProjects();
  this.getAll();});
      }
    });
};
getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
 
   loadProjects = () => {
   axios
    .get(Serverurl + "ajaxprojects.php?action=getallprojectautoextender&pj_isactive=0")
    .then((res) => {
      this.setState({ projectList: res.data  });
 this.loadServices();
    });
};
loadServices = () => {
  axios
    .get(Serverurl + "ajaxserviceandexpenses.php?action=getalldropdown")
    .then((res) => {
      this.setState({ serviceList: res.data });
      this.loadVendors();
    });
};
loadVendors = () => {
   axios
    .get(Serverurl +"ajaxvendor.php?action=vendorautoextender")
    .then((res) => {
      this.setState({ vendorList: res.data });
    });
};
  getAll = () => {
	  
	  let pjid="",srid="",venid="";
	  if(this.state.serProject!=null )
	  {
		 
	  pjid=this.state.serProject.pj_id
	  }
	   if(this.state.serService!=null )
	  {
		 
	  srid=this.state.serService.se_id
	  }
	   if(this.state.serVendor!=null )
	  {
		 
	  venid=this.state.serVendor.vm_id
	  }
   axios.get(`${Serverurl}ajaxcontractcostmap.php?action=getall&StartIndex=${this.state.page}&PageSize=${this.state.rowsPerPage}&sorting=ccm_id desc&ccm_pj_id=${pjid}&ccm_se_id=${srid}&ccm_vm_id=${venid}`)
      .then((res) => {
        this.setState({
          contractcostlist: res.data || [],
          totalRecords: res.data[0].count,
        });
      });
  };
  handleNumericChange = (field, e) => {
    const value = e.target.value;
    if (/^\d*\.?\d*$/.test(value)) {
      this.setState({ [field]: value });
    }
  };
 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 
saveData = () => {
 
if(this.state.ccm_pj_id==="")
{
	
	this.setState({errormessage:"Please Select Project ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(this.state.ccm_se_id==="")
{
	
	this.setState({errormessage:"Please Select Service ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(this.state.ccm_vm_id==="")
{
	
	this.setState({errormessage:"Please Select Vendor ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(this.state.ccm_agreedcost==="")
{
	
	this.setState({errormessage:"Please Enter Agreed Cost ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}

  let formData = new FormData();

  formData.append("action", "insertupdate");
  formData.append("ccm_id", this.state.ccm_id || 0);
  formData.append("ccm_pj_id", this.state.ccm_pj_id);
  formData.append("ccm_se_id", this.state.ccm_se_id);
  formData.append("ccm_vm_id", this.state.ccm_vm_id);
  formData.append("ccm_agreedcost", this.state.ccm_agreedcost);
  formData.append("ccm_remarks", this.state.ccm_remarks);
  formData.append("userid",localStorage.getItem("VRuserid"));

  axios
    .post(Serverurl + "ajaxcontractcostmap.php", formData, {
        }).then(res => {
    if(res.data === -1)
{ 
	 

		this.setState({errormessage:"Service Already Mapped.",erropen:true,open:true
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}
	
	
	
            //this.props.updateDonenew();
    
      
		
      this.setState({
        openInsert: false,
        openEdit: false,
        ccm_id: 0,
        ccm_pj_id: "",
        ccm_se_id: "",
        ccm_vm_id: "",
        ccm_agreedcost: "",
        ccm_remarks: "",
        selectedProject: null,
        selectedService: null,
        selectedVendor: null,
      });

      this.getAll();
    });
};
  deleteRecord = (id) => {
    if (!window.confirm("Are you sure?")) return;
    let formData = new FormData();
    formData.append("action", "delete");
    formData.append("ccm_id", id);
    formData.append("userid", localStorage.getItem("VRuserid"));
    axios.post(Serverurl + "ajaxcontractcostmap.php", formData)
      .then(() => this.getAll());
  };
 editRecord = (row) => {
  this.setState(
    {
      ccm_id: row.ccm_id,
      ccm_pj_id: row.ccm_pj_id,
      ccm_se_id: row.ccm_se_id,
      ccm_vm_id: row.ccm_vm_id,
      ccm_agreedcost: row.ccm_agreedcost,
      ccm_remarks: row.ccm_remarks,
      selectedProject: {
        title: row.pj_projectname,
        pj_id: row.ccm_pj_id
      },
      selectedService: {
        title: row.se_servicename,
        se_id: row.ccm_se_id
      },
      selectedVendor: {
        title: row.vm_vendorname,
        vm_id: row.ccm_vm_id
      },
      openInsert: true
    },
    () => {
      axios
        .get(Serverurl + "ajaxvendor.php", {
          params: {
            action: "getbyservice",
            se_id: row.ccm_se_id
          }
        })
        .then((res) => {
          const vendorarrauto = (res.data || []).map((v) => ({
            title: v.vm_vendorname,
            vm_id: v.vm_id
          }));
          this.setState({
            vendorList: res.data || [],
            vendorarrauto
          });
        });
    }
  );
};
  openInsert = () => {
  this.setState({
    openInsert: true,
    ccm_id: 0,
    ccm_pj_id: "",
    ccm_se_id: "",
    ccm_vm_id: "",
    ccm_agreedcost: "",
    ccm_remarks: "",
    selectedProject: null,
    selectedService: null,
    selectedVendor: null
  });
};
  closeInsert = () => {
    this.setState({ openInsert: false });
  };
handleClose = () => {
  this.setState({
    openEdit: false,
    ccm_id: 0,
    ccm_pj_id: "",
    ccm_se_id: "",
    ccm_vm_id: "",
    ccm_agreedcost: "",
    ccm_remarks: "",
    selectedProject: null,
    selectedService: null,
    selectedVendor: null
  });
};
  /*project autoextender*/
  onloadProjectBind = (event) => {
  axios
    .get(Serverurl + "ajaxprojects.php", {
      params: {
        action: "getallprojectautoextender",
        projectname: event.target.value
      }
    })
    .then((resp) => {
      let arr = [];
      (resp.data || []).forEach((row) => {
        if (!arr.some((x) => x.pj_id === row.pj_id)) {
          arr.push({
            title: row.pj_projectname,
            pj_id: row.pj_id
          });
        }
      });
      this.setState({
        projectarray: resp.data || [],
        projectarrauto: arr
      });
    });
};
onProjectChange = (event, value) => {
  this.setState({
    selectedProject: value,
    ccm_pj_id: value ? value.pj_id : ""
  });
};

onserProjectChange = (event, value) => {
  this.setState({
    serProject: value,
  
  });
};
/*service autoextender*/
onloadServiceBind = (event) => {
  axios
    .get(Serverurl + "ajaxserviceandexpenses.php", {
      params: {
        action: "getalldropdown",
        servicename: event.target.value
      }
    })
    .then((resp) => {
      let arr = [];
      (resp.data || []).forEach((row) => {
        if (!arr.some((x) => x.se_id === row.se_id)) {
          arr.push({
            title: row.se_servicename,
            se_id: row.se_id
          });
        }
      });
      this.setState({
        servicearray: resp.data || [],
        servicearrauto: arr
      });
    });
};
  handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
   

    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{  this.getAll(); }); 
	
	
  }; 
  
  
 handleChangePage = (event, newPage) => {  
   
  
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{  this.getAll(); });
   
 
 
  }; 

onServiceChange = (event, value) => {
  const se_id = value ? value.se_id : "";
  this.setState(
    {
      selectedService: value,
      ccm_se_id: se_id,
      ccm_vm_id: "",
      selectedVendor: null,
      vendorarrauto: []
    },
    () => {
      if (!se_id) return;
      axios
        .get(Serverurl + "ajaxvendor.php", {
          params: {
            action: "getbyservice",
            se_id: se_id
          }
        })
        .then((res) => {
          let arr = [];
          (res.data || []).forEach((row) => {
            if (!arr.some((x) => x.vm_id === row.vm_id)) {
              arr.push({
                title: row.vm_vendorname,
                vm_id: row.vm_id
              });
            }
          });
          this.setState({
            vendorList: res.data || [],
            vendorarrauto: arr
          });
        });
    }
  );
};

onserServiceChange = (event, value) => {
	  let se_id = value ? value.se_id : "";
	  this.setState(
    {
      serService: value,
      ccm_se_id: se_id,
      ccm_vm_id: "",
      serVendor: null,
      vendorarrauto: []
    },
    () => {
      if (!se_id) return;
      axios
        .get(Serverurl + "ajaxvendor.php", {
          params: {
            action: "getbyservice",
            se_id: se_id
          }
        })
        .then((res) => {
          let arr = [];
          (res.data || []).forEach((row) => {
            if (!arr.some((x) => x.vm_id === row.vm_id)) {
              arr.push({
                title: row.vm_vendorname,
                vm_id: row.vm_id
              });
            }
          });
          this.setState({
            vendorList: res.data || [],
            vendorarrauto: arr
          });
        });
    }
  );
};
/*vendor autoextender*/
onloadVendorBind = (event) => {
  if (!this.state.ccm_se_id) return;
  axios
    .get(Serverurl + "ajaxvendor.php", {
      params: {
        action: "getbyservice",
        se_id: this.state.ccm_se_id,
        vm_vendorname: event.target.value
      }
    })
    .then((resp) => {
      let arr = [];
      (resp.data || []).forEach((row) => {
        if (!arr.some((x) => x.vm_id === row.vm_id)) {
          arr.push({
            title: row.vm_vendorname,
            vm_id: row.vm_id
          });
        }
      });
      this.setState({
        vendorarray: resp.data || [],
        vendorarrauto: arr
      });
    });
};
onVendorChange = (event, value) => {
  this.setState({
    selectedVendor: value,
    ccm_vm_id: value ? value.vm_id : ""
  });
};

onserVendorChange = (event, value) => {
  this.setState({
    serVendor: value,
   
  });
};

handleClickSearch=()=>{   
 
  
  this.getAll();

	
} 
  render() {
    // 
    const filteredVendors = this.state.vendorList.filter(
      (v) => String(v.vm_se_id) === String(this.state.ccm_se_id)
    );
    return (
	
	
	  <React.Fragment>
	<div className="searchmaster">


  
  <ul>
  

		
		<li> <p>
      Project
    </p> 
		<p>
    <FormControl fullWidth size="small">
     <Autocomplete
  options={this.state.projectarrauto}
  value={this.state.serProject} className="inputcntlparent"
  onChange={this.onserProjectChange}
  getOptionLabel={(option) => option.title || ""}
  renderInput={(params) => (
    <TextField
      {...params} 
      size="small" 
      placeholder="Search Project"
      onChange={this.onloadProjectBind}
	
    />
  )}
  fullWidth
/>
    </FormControl>
  </p>
		</li>
		<li> <p>
      Service
    </p> 
		<p>
    <FormControl fullWidth size="small">
      <Autocomplete
  options={this.state.servicearrauto} className="inputcntlparent"
  value={this.state.serService}
  onChange={this.onserServiceChange}
  getOptionLabel={(option) => option.title || ""}
  renderInput={(params) => (
    <TextField
      {...params}
      size="small"
      placeholder="Search Service"
      onChange={this.onloadServiceBind}
	
    />
  )}
  fullWidth
/>
    </FormControl>
  </p>
		</li>
		<li>
		   <p>
      Vendor
    </p>  <p>
    <FormControl fullWidth size="small">
      <Autocomplete
  options={this.state.vendorarrauto} className="inputcntlparent"
  value={this.state.serVendor}
  onChange={this.onserVendorChange}
  getOptionLabel={(option) => option.title || ""}
  renderInput={(params) => (
    <TextField
      {...params}
      size="small"
      placeholder="Search Vendor"
      onChange={this.onloadVendorBind}
	     
    />
  )}
  fullWidth
/>
    </FormControl>
  </p>
		</li>
		<li>
		<Button variant="contained" onClick={this.handleClickSearch} className={useStyles.submit} endIcon={<SearchIcon />}>
        Search
      </Button>    <Button variant="contained" onClick={this.openInsert} className="pointerbtn" endIcon={<AddIcon />}>
          New
        </Button>
		</li>
		</ul>
		</div>
      <Paper>
       
     
        <Table sx={{ mt: 3 }}>
          <TableHead>
            <TableRow>
              <TableCell>Project</TableCell>
              <TableCell>Service</TableCell>
              <TableCell>Vendor</TableCell>
              <TableCell>Cost</TableCell>
              <TableCell>Remarks</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.contractcostlist.map((row) => (
              <TableRow key={row.ccm_id}>
                <TableCell>{row.pj_projectname}</TableCell>
                <TableCell>{row.se_servicename}</TableCell>
                <TableCell>{row.vm_vendorname}</TableCell>
                <TableCell>Rs.{parseFloat(row.ccm_agreedcost).toLocaleString("en-IN")}</TableCell>
                <TableCell>{row.ccm_remarks}</TableCell>
                <TableCell>
				{row.pj_isactive==="0" && (  <React.Fragment>
                  <Button variant="contained" className="editbtn" onClick={() => this.editRecord(row)} endIcon={<EditIcon />}>
                    
                  </Button>
                  <Button sx={{ ml: 1 }} variant="contained" className="deletebtn" onClick={() => this.deleteRecord(row.ccm_id)} endIcon={<DeleteIcon />}>
              
                  </Button>
				  </React.Fragment>)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination  
        rowsPerPageOptions={[10,20, 100, 150, 200, 250]}  
        component="div"  
        count={this.state.totalRecords}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      />
        {/* INSERT DIALOG */}
        <Dialog open={this.state.openInsert} onClose={this.closeInsert} maxWidth="md" fullWidth="true">
          <DialogTitle>Contract Cost Mapping</DialogTitle>
          <DialogContent>
          <p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
           <div className="contractbox">

    <p>
      Project
    </p>  <p>
    <FormControl fullWidth size="small">
     <Autocomplete
  options={this.state.projectarrauto}
  value={this.state.selectedProject} className="inputcntlparent"
  onChange={this.onProjectChange}
  getOptionLabel={(option) => option.title || ""}
  renderInput={(params) => (
    <TextField
      {...params} 
      size="small" 
      placeholder="Search Project"
      onChange={this.onloadProjectBind}
	
    />
  )}
  fullWidth
/>
    </FormControl>
  </p></div>
  {/* SERVICE */}
 <div className="contractbox">
    <p>
      Service
    </p>  <p>
    <FormControl fullWidth size="small">
      <Autocomplete
  options={this.state.servicearrauto} className="inputcntlparent"
  value={this.state.selectedService}
  onChange={this.onServiceChange}
  getOptionLabel={(option) => option.title || ""}
  renderInput={(params) => (
    <TextField
      {...params}
      size="small"
      placeholder="Search Service"
      onChange={this.onloadServiceBind}

    />
  )}
  fullWidth
/>
    </FormControl>
  </p>
  </div>
 <div className="contractbox">
    <p>
      Vendor
    </p>  <p>
    <FormControl fullWidth size="small">
      <Autocomplete
  options={this.state.vendorarrauto} className="inputcntlparent"
  value={this.state.selectedVendor}
  onChange={this.onVendorChange}
  getOptionLabel={(option) => option.title || ""}
  renderInput={(params) => (
    <TextField
      {...params}
      size="small"
      placeholder="Search Vendor"
      onChange={this.onloadVendorBind}
	  
    />
  )}
  fullWidth
/>
    </FormControl>
  </p>
  </div>
 <div className="clear"></div>
 <div className="contracthalf">
    <p>
      Agreed Cost
    </p> <p>
    <TextField
      fullWidth className="inputcntlparent"
      size="small"
	  
	  slotProps={{
    htmlInput: {
      maxLength: 10,
      tabIndex: 4
    },
    input: {
      endAdornment: (
        <InputAdornment position="end">
          <CurrencyRupeeIcon   sx={{ color: "#206ccc", fontSize: 20 }} />
        </InputAdornment>
      )
    }
  }}
      value={this.state.ccm_agreedcost}
      onChange={(e) =>
        this.handleNumericChange("ccm_agreedcost", e)
      }
    />
  </p></div>
  {/* REMARKS */}
  <div className="contracthalf">
    <p>
      Remarks
    </p> <p>
    <TextField
      fullWidth
      size="small"
      multiline
      rows={3}   slotProps={{
    htmlInput: {
     
      tabIndex: 5
    },
    input: {
      endAdornment: (
         <InputAdornment position="end" sx={{
          alignSelf: "flex-start",  
          mt: "6px"                 
        }}>
          <NotesIcon   sx={{ color: "#206ccc", fontSize: 20 }} />
        </InputAdornment>
      )
    }
  }}
      value={this.state.ccm_remarks}
      onChange={(e) =>
        this.setState({ ccm_remarks: e.target.value })
      }
    />
  </p></div>
         <div className="clear"></div>
		  <div className="actionbtns">
			 <div className="cancelbtn">	
            <Button className="frmsecondarybtn" onClick={this.closeInsert}>Cancel</Button>
			</div> 
<div className="savebtn">
            <Button className="frmPrimarybtn" variant="contained" onClick={this.saveData}>
              Save
            </Button>
					</div>
<div className="clear"></div>

 </div> 
          </DialogContent>
          
        </Dialog>
       
      </Paper>
	  	  </React.Fragment>
    );
  }
}
export default ContractCostMap;